/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const PlusCircleIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-3v-4h4V9h-4V5H9v4H5v2h4v4z"
    clipRule="evenodd"
  />,
);
